import { Component, OnInit, signal, WritableSignal } from "@angular/core";
import { Subject } from "rxjs";
import { GlobalServicesService } from "src/app/services/global-services.service";

type ConfigurationTabs = "Candidate Source" | "Event Category" | "Event Type" | "Role Type"
const privilegeMap: Record<string, { create: string; update: string; delete: string }> = {
    'Candidate Source': {
        create: 'candidate_source.create',
        update: 'candidate_source.update',
        delete: 'candidate_source.delete',
    },
    'Event Category': {
        create: 'event_category.create',
        update: 'event_category.update',
        delete: 'event_category.delete',
    },
    'Event Type': {
        create: 'event_type.create',
        update: 'event_type.update',
        delete: 'event_type.delete',
    },
    'Role Type': {
        create: 'role_type.create',
        update: 'role_type.update',
        delete: 'role_type.delete',
    },
};

@Component({
    selector: 'app-configuration-settings',
    templateUrl: './configuration-settings.component.html',
    styleUrls: ['./configuration-settings.component.css'],
    standalone: false
})
export class ConfigurationSettingsComponent implements OnInit {
    currentTab: WritableSignal<ConfigurationTabs> = signal<ConfigurationTabs>("Candidate Source");
    userPrivileges: Set<string> = new Set();
    openSideBar$: Subject<void> = new Subject<void>();

    constructor(
        private globalService: GlobalServicesService,
    ) { }

    ngOnInit(): void {
        this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
            this.userPrivileges = privileges;
        });
    }

    switchCurrentTab(tab: ConfigurationTabs) {
        this.currentTab.set(tab);
    }

    get canCreate(): boolean {
        const key = privilegeMap[this.currentTab()]?.create;
        return key ? this.userPrivileges.has(key) : false;
    }
}